<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t(`iamee.remove_someone`, [$t(`dictionary.${params.type}`)])}}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('iamee.node')" :count="params.data.length" :action="$t(`iamee.remove_someone`, [$t(`dictionary.${params.type}`)])" />
      <dialog-table :data="params.data" :columns="params.columns" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'OrganizationUnbindDialog',
  components: {
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  created () {
    this.$oM = new this.$Manager('organization_nodes', 'v1')
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await this.$oM.performAction({
          id: this.params.orgNodeId,
          action: 'unbind',
          data: {
            target_id: this.params.targets.map(item => item.id),
            resource_type: this.params.type,
          },
        })
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
